import React from "react";
import {Icon} from "semantic-ui-react"
import { InputField } from 'KN-EU-Broker-Dashboard-UI'

const FileUploadContent = ({setFile, setDisplayMsg}) => {
    const fileUpload = (e)=>{
        const file = e.target.files[0];
        if(file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
            setDisplayMsg({color: "black", message: "", title: ""})
            setFile(e.target.files[0]);
        }
        else{
            setDisplayMsg({color: "red", message: "Please upload the correct format file.", title: "Wrong File Format"})
        }
    }
    
    return ( <>
        <InputField className="upload-file" onChange={fileUpload} type="file" accept=".xls,.xlsx" />
        <br />
        {/* <Icon name="file excel outline"/><a href="/reconFileTemplate/Recon_Entries_Template_3.0.xlsx" download  >
            Download Template Here
        </a> */}
    </> );
}
 
export default FileUploadContent;